import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import './Header.css';/* empty css            */
const HeaderLink = ({
  children,
  icon,
  active,
  className,
  iconPosition = "left",
  iconGapSize = "normal",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "text",
      icon: icon ? /* @__PURE__ */ jsx(Icon, { name: icon }) : null,
      iconPosition,
      iconGapSize,
      className: classnames(
        [
          "perxis-auto-header-link",
          {
            "perxis-auto-header-link--active": !!active
          }
        ],
        className
      ),
      ...props,
      children
    }
  );
};
export {
  HeaderLink as default
};
//# sourceMappingURL=HeaderLink.js.map
